<template>
  <section
    v-if="text || (viewer?.is_owner && ownerViewMode)"
    id="about"
    class="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-20"
    aria-labelledby="about-heading-t1"
  >
    <h2 id="about-heading-t1" class="text-3xl font-bold tracking-tight mb-8 text-t1-neutral-dark">{{ $t('public.about') }}</h2>
    <p v-if="text" class="text-t1-neutral-muted whitespace-pre-line">{{ text }}</p>
    <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-4 px-4 rounded border border-dashed border-t1-neutral-dark/40 bg-t1-neutral-dark/5">
      <p class="text-sm font-mono text-t1-neutral-dark/70">{{ $t('public.noDescriptionSetOwnerMessage') }}</p>
    </div>
  </section>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})
</script>
